import { useSelector } from "react-redux";
import { ErrorBoundary } from "./RouteError";
import { RootState } from "../../redux/store";

const ErrorWatcher = () => {
  const error = useSelector((state: RootState) => state.Error.error);
  return error ? <ErrorBoundary /> : null;
};

export default ErrorWatcher;
